import { render, staticRenderFns } from "./base-layout.component.vue?vue&type=template&id=ac21f64e"
import script from "./base-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./base-layout.component.ts?vue&type=script&lang=ts&external"
import style0 from "./base-layout.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports